﻿﻿export interface IPhlebotRequest {
    //recipient info
    id: number,
    alias: string,
    firstName: string,
    middleName: string,
    lastName: string,
    birthDate: Date,
    email: string,
    phoneNumber: string,
    receiverType: string,

    //address info
    address: string,
    address2: string,
    city: string,
    state: number,
    postalCode: string,
   
    //request info
    kitId: string, //??

    kitType: number,
    status: number,
    description: string,
    vendor: number,
    notes: string,
    officeContactDetails: string,
    
    trackingId: string,
    transactionUniqueId: string,
    
    dateCreated: Date,
    dateUpdated: Date,
    dateScheduled: Date,
    dateCompleted: Date
}